import Link from 'next/link';
import { ReactNode } from 'react';

type LinkCustomProps = {
    href: string;
    children: ReactNode;
    replace: boolean;
    scroll: boolean;
    prefetch: boolean;
};

export function LinkCustom({ href, prefetch = false, children, ...props }: Readonly<LinkCustomProps>) {
    return (
        <Link href={href} prefetch={prefetch} {...props}>
            {children}
        </Link>
    );
}
